export default function () {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    $('input#timezone').val(timezone);
}